import CadastroClienteModal from './CadastroClienteModal';

export default CadastroClienteModal;
